import React, { useContext } from 'react';
import { Card, Flex, Heading, TextButton } from '@zillow/constellation';
import Markdown from '../../../components/Markdown';
import { URLS } from '../../../constants/urls';
import { ComplianceMessagingContext } from '../../../contexts/ComplianceMessagingContext';

export default function LocalLandlordAdvisory() {
  const { complianceList, isLoading, error } = useContext(ComplianceMessagingContext);

  return (
    !isLoading &&
    !error &&
    complianceList.length > 0 && (
      <Card id="local-landlord-advisory" cardType="secondary" padding={{ default: 'sm', lg: 'lg' }} marginTop="lg">
        <Heading level={4} marginBottom="sm">
          Local landlord advisory
        </Heading>
        <Flex display="flex" flexDirection="column" gap="sm">
          {complianceList.map((compliance) => (
            <Markdown key={compliance.id}>{compliance.body}</Markdown>
          ))}
        </Flex>
        <TextButton as="a" href={URLS.COMPLIANCE_LEARN_MORE} target="_blank" marginTop="sm">
          Learn more
        </TextButton>
      </Card>
    )
  );
}
